import React from 'react';
import { FileText } from 'lucide-react';
export function EvaluationProgressWidget() {
  // Mock data
  const evaluationData = {
    campaignName: 'Évaluation annuelle 2023',
    dueDate: '15 déc. 2023',
    totalEvaluations: 5,
    completed: 1,
    inProgress: 2,
    notStarted: 2
  };
  const progressPercentage = Math.round(evaluationData.completed / evaluationData.totalEvaluations * 100);
  return <div className="bg-white rounded-lg shadow-sm p-5" data-id="element-1901">
      <div className="flex items-center justify-between mb-4" data-id="element-1902">
        <h3 className="font-semibold text-gray-900" data-id="element-1903">Campagne d'évaluation</h3>
        <FileText className="h-5 w-5 text-blue-600" data-id="element-1904" />
      </div>
      <div className="mb-4" data-id="element-1905">
        <p className="font-medium text-gray-900" data-id="element-1906">
          {evaluationData.campaignName}
        </p>
        <p className="text-sm text-gray-600" data-id="element-1907">
          Date limite: {evaluationData.dueDate}
        </p>
      </div>
      <div className="mb-4" data-id="element-1908">
        <div className="flex justify-between mb-1" data-id="element-1909">
          <span className="text-sm text-gray-600" data-id="element-1910">Progression</span>
          <span className="text-sm font-medium text-gray-700" data-id="element-1911">
            {progressPercentage}%
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2.5" data-id="element-1912">
          <div className="bg-blue-600 h-2.5 rounded-full" style={{
          width: `${progressPercentage}%`
        }} data-id="element-1913"></div>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-4" data-id="element-1914">
        <div className="bg-green-50 p-2 rounded text-center" data-id="element-1915">
          <span className="block text-lg font-semibold text-green-600" data-id="element-1916">
            {evaluationData.completed}
          </span>
          <span className="text-xs text-green-800" data-id="element-1917">Terminées</span>
        </div>
        <div className="bg-blue-50 p-2 rounded text-center" data-id="element-1918">
          <span className="block text-lg font-semibold text-blue-600" data-id="element-1919">
            {evaluationData.inProgress}
          </span>
          <span className="text-xs text-blue-800" data-id="element-1920">En cours</span>
        </div>
        <div className="bg-gray-50 p-2 rounded text-center" data-id="element-1921">
          <span className="block text-lg font-semibold text-gray-600" data-id="element-1922">
            {evaluationData.notStarted}
          </span>
          <span className="text-xs text-gray-800" data-id="element-1923">Non démarrées</span>
        </div>
      </div>
      <button className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white rounded-md text-sm font-medium transition-colors duration-150 ease-in-out" data-id="element-1924">
        Gérer les évaluations
      </button>
    </div>;
}